import { ButtonHTMLAttributes } from 'react';
import { cn } from 'shared/utils/cn';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'ghost-inverse' | 'neutral';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary: 'bg-primary text-surface hover:bg-primary-dark hover:shadow-glow',
  secondary: 'bg-accent-soft text-primary hover:bg-accent',
  ghost: 'bg-transparent text-primary border border-primary hover:bg-accent-soft',
  'ghost-inverse': 'bg-transparent text-surface border border-accent hover:bg-primary-dark',
  // Ação secundária ao lado de um botão primário (Voltar, Cancelar): cinza, sem disputar atenção.
  neutral: 'bg-surface text-ink border border-border hover:bg-chip',
};

export function Button({ variant = 'primary', className, ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 font-medium transition-all duration-200 active:scale-[0.97] disabled:cursor-not-allowed disabled:opacity-60 disabled:active:scale-100',
        VARIANT_CLASSES[variant],
        className
      )}
      {...props}
    />
  );
}
